import { Controller } from '@hotwired/stimulus';

const INTERACTIVE_SELECTOR =
  'a, button, input, textarea, select, option, label, dialog, [contenteditable="true"]';

export default class extends Controller {
  static values = { url: String };

  follow(event) {
    // Nested controls (e.g. email modal fields) must not trigger row navigation.
    if (event.target.closest(INTERACTIVE_SELECTOR)) return;

    if (event.type === 'keydown') {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
    }

    window.location.assign(this.urlValue);
  }
}
